import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
var Score = function (props) {
    if (props.score === undefined) {
        return false;
    }
    var score1 = props.score.get('score1');
    var score2 = props.score.get('score2');
    if (props.mainScore) {
        if (score1 > score2) {
            return _jsxs("span", { children: [_jsxs("strong", { children: [score1, " : "] }), score2] });
        }
        else if (score1 < score2) {
            return _jsxs("span", { children: [score1, " : ", _jsx("strong", { children: score2 })] });
        }
        return _jsxs("span", { children: [score1, " : ", score2] });
    }
    return _jsxs("span", { children: ["(", score1, ":", score2, ")\u00A0"] });
};
Score.propTypes = {
    score: PropTypes.object,
    mainScore: PropTypes.bool
};
export default Score;



// WEBPACK FOOTER //
// ./src/components/info/results/Score.jsx